module.exports = __webpack_public_path__ + "static/photo_6-6018997520e556c01fe372a2cd87db4f.jpg";